module.exports = __webpack_public_path__ + "static/img/default.85353712.jpg";